"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcPriceImpactWithAmount = void 0;
const unit_1 = require("@keplr-wallet/unit");
function calcPriceImpactWithAmount(spotPriceBefore, tokenAmount, priceImpact) {
    const effectivePrice = spotPriceBefore.mul(priceImpact.add(new unit_1.Dec(1)));
    return new unit_1.Dec(tokenAmount).quo(effectivePrice).truncate();
}
exports.calcPriceImpactWithAmount = calcPriceImpactWithAmount;
//# sourceMappingURL=general.js.map